import { useCallback } from 'react'

/**
 * Builds direct DocuWare PDF links.
 *
 * No document passes through our servers: the returned URL points straight at the
 * DocuWare host and the browser authenticates with the user's own DocuWare session.
 *
 * A DocuWare document ID is only unique inside its own file cabinet, so both the
 * cabinet and the id must be present. When either is missing the hook returns null,
 * which callers should render as "no button" rather than a broken link.
 *
 * @param cabinet DocuWare file cabinet GUID for the record's branch (Sucursal)
 * @param baseUrl DocuWare server base URL, injected as a page prop
 */
export function useDocuwareLink(cabinet?: string, baseUrl?: string) {
  return useCallback(
    (docId?: string | number | null): string | null => {
      if (!cabinet || !baseUrl) return null

      const id = docId == null ? '' : String(docId).trim()
      if (!id || id === 'null' || id === 'undefined') return null

      return (
        `${baseUrl}/DocuWare/PlatformRO/FileCabinets/${encodeURIComponent(cabinet)}` +
        `/Documents/${encodeURIComponent(id)}/FileDownload` +
        `?targetFileType=PDF&keepAnnotations=true&downloadFile=true&autoPrint=false&layers=1`
      )
    },
    [cabinet, baseUrl]
  )
}

export default useDocuwareLink
